import Controller from './admin/dropzone_controller'
export default Controller